/* useClickOutsideHandler.ts */

import React, { useEffect } from "react";

/* Interfaces */
interface ClickOutsideHandlerProps {
  ref: React.RefObject<HTMLDivElement | null>;
  onClick: (value: boolean) => void;
}

const useClickOutsideHandler = ({
  ref,
  onClick,
}: ClickOutsideHandlerProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        onClick(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, [ref, onClick]);
};

export default useClickOutsideHandler;
